import {Environment, graphql} from 'react-relay';
import type {Disposable} from 'relay-runtime';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from './MutationTypes';
import {
	SetReportSharePermissionInput,
	setReportSharePermissionMutation,
} from './__generated__/setReportSharePermissionMutation.graphql';

const mutation = graphql`
	mutation setReportSharePermissionMutation($input: SetReportSharePermissionInput!) {
		setReportSharePermission(input: $input) {
			share {
				id
				permissionType
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<SetReportSharePermissionInput>,
	onSuccess?: RelayOnCompleted<setReportSharePermissionMutation>,
	onError?: RelayOnError
): Disposable {
	tracking.trackEvent('Report Share Permission Changed');

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		// The mutation returns the updated share, and Relay writes the new permissionType into the
		// store by id, so no configs are needed - nothing enters or leaves a connection.
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
